import {
  AddPage,
  EditPage,
  TablePage,
  ViewPage,
} from 'src/views/clog/mgtt/mgttadminconfig'

import pathMap from 'src/paths/pathMap'

class MGTTAdminConfigRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.MGTT_ADMIN_CONFIG_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.MGTT_ADMIN_CONFIG_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.MGTT_ADMIN_CONFIG_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.MGTT_ADMIN_CONFIG_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default MGTTAdminConfigRoute
